import React from "react";
import dotAccess from "dot-access";

export const ShowBasedOnCondition = (props) => {
    const {condition, evaluateOnField, children, resource, ...other} = props;

    const fieldValue = dotAccess.get(resource, evaluateOnField);
    if (!fieldValue || !condition || !condition(fieldValue)) {
        return null;
    }

    return React.cloneElement(React.Children.only(children), {...other, resource});
}




// WEBPACK FOOTER //
// ./src/main/components/container/ShowBasedOnCondition.js